(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enruige-kit-size-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-kit-size-link]');
    if (!link) return;
    const destination = new URL(link.href);
    const current = new URL(window.location.href);
    current.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') {
        destination.searchParams.set(key, value);
      }
    });
    link.href = destination.toString();
  });
  } catch(e) { console.error(e); }
})();

})();
